import React from "react";
import {
  Box,
  Container,
  Header,
  SpaceBetween,
  Spinner,
  ExpandableSection,
} from "@amzn/awsui-components-react";
import MarkdownView from "./components/MarkdownView";

/**
 * FAQ tab: questions grouped by category, each rendered as an expandable
 * section whose answer is Markdown (rendered safely, links open in a new tab).
 * Uncategorized questions render in a trailing "General" group.
 */
const FaqList = ({ faqs }) => (
  <SpaceBetween size="xs">
    {faqs.map((faq) => (
      <ExpandableSection
        key={faq.faq_id}
        headerText={faq.question}
        defaultExpanded
      >
        <MarkdownView>{faq.answer}</MarkdownView>
      </ExpandableSection>
    ))}
  </SpaceBetween>
);

const Faq = ({ faq }) => {
  if (!faq) {
    return (
      <Box padding="l">
        <Spinner /> Loading FAQ...
      </Box>
    );
  }

  const categories = [...(faq.categories || [])].sort(
    (a, b) => (a.sort_order || 0) - (b.sort_order || 0)
  );
  const uncategorized = faq.uncategorized || [];

  const hasContent =
    categories.some((cat) => (cat.faqs || []).length > 0) || uncategorized.length > 0;

  if (!hasContent) {
    return <Box variant="p">No FAQs have been published yet.</Box>;
  }

  return (
    <SpaceBetween size="l">
      {categories
        .filter((cat) => (cat.faqs || []).length > 0)
        .map((cat) => (
          <Container
            key={cat.category_id}
            header={<Header variant="h3">{cat.name}</Header>}
          >
            <FaqList faqs={cat.faqs} />
          </Container>
        ))}
      {uncategorized.length > 0 ? (
        <Container header={<Header variant="h3">General</Header>}>
          <FaqList faqs={uncategorized} />
        </Container>
      ) : null}
    </SpaceBetween>
  );
};

export default Faq;
